import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RouterOutlet } from '@angular/router';

import { AuthStore } from './auth/store';
import { OrganizationVerificationModal } from './components/organization-verification-modal/organization-verification-modal';
import { Footer } from './layout/footer/footer';
import { Layout } from './layout/layout/layout';
import { Header } from './layout/header/header';

@Component({
  selector: 'app-root',
  imports: [Layout, Footer, RouterOutlet, Header],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private readonly authStore = inject(AuthStore);
  private readonly dialog = inject(MatDialog);

  constructor() {
    effect(() => {
      if (!this.authStore.isAuthenticated()) {
        return;
      }

      if (this.authStore.isUserIndividual() || this.authStore.isOrgVerified()) {
        return;
      }

      this.openOrganizationVerificationModal();
    });
  }

  ngOnInit(): void {
    if (this.authStore.user() === null) {
      this.authStore.getSession();
    }
  }

  openOrganizationVerificationModal(): void {
    this.dialog.open(OrganizationVerificationModal, {
      autoFocus: 'dialog',
      minWidth: 'min(480px, 100vw - 32px)',
      maxWidth: '560px',
      panelClass: 'organization-verification-modal-panel',
      ariaLabelledBy: 'organization-verification-modal-title',
      ariaDescribedBy: 'organization-verification-modal-desc',
    });
  }
}
